import { AdminSubPage } from "@/components/admin/AdminSubPage";
import { ArticlesAdmin } from "@/components/admin/ArticlesAdmin";

export default function AdminArticles() {
  return (
    <AdminSubPage testId="admin-articles-page" title="Artikel blog" subtitle="Tulis, edit, dan atur artikel yang tampil di halaman /blog.">
      <ArticlesAdmin />
    </AdminSubPage>
  );
}
